import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ITicketModalPopupAction } from "../../../Orchestrator/Types/Interface/EventParams/TicketAction";

export class TicketPopupOpenCloseAction extends BaseAction<boolean, ITicketModalPopupAction> {

    override async run(): Promise<boolean> {
        try {
            const { bookingId, isVisible, trip } = this.params!;
            updateRecoilState("modalStateTicketAtom", {
                bookingId: bookingId,
                isVisible: isVisible
            })

            if(isVisible && trip) {
                updateRecoilState("displayPassengerDataAtom", trip.passengers);
                updateRecoilState("selectedTripsDataAtom", trip);
            } 
            else {
                updateRecoilState("displayPassengerDataAtom", null);
            }
        } catch (error) {
            console.error("Error in TicketPopupOpenCloseAction:", error);
        } finally {
            return true;
        }
    }
}

// Create a singleton instance
export const ticketPopupOpenCloseAction = new TicketPopupOpenCloseAction(); 